import axios from "axios";

export function getBankDetails(data){
    return axios.get(`http://localhost:3500/bankDetails`);
}